import { DropDownList } from '@progress/kendo-react-dropdowns'
import { useComponentProperties, useFetchedValues } from '../../../../Hooks/Display/useComponentProperties';
import { useEffect, useState } from 'react';
import { useSelectedComponent } from '../../../../Hooks/Display/useComponents';
import { useTranslation } from 'react-i18next';
import { byAttributeName } from '../../utils';

function MappingAttributesForGanntChart() {

    const selectedComponent = useSelectedComponent();

    const [properties, setProperty] = useComponentProperties();
    const [{ generalProperties: fetchedValues }] = useFetchedValues();

    const [mappingAttributes, setMappingAttributes] = useState([]);

    const { t } = useTranslation("display/components/calendar");

    useEffect(() => {
        if (fetchedValues.attributes && fetchedValues.attributes.length > 0) {
            const mappingAttributes = fetchedValues.attributes
                                .filter(attribute => {
                                    // Exclude attributes with formulaEnabled in triggerSetting
                                    if (attribute.triggerSetting && JSON.parse(attribute.triggerSetting).formulaEnabled) {
                                        return false;
                                    }

                                    // Include only non-system DateTime attributes that are not "time" type
                                    return (
                                        !attribute.isSystemAttribute &&
                                        attribute.attributeType === "DateTime" &&
                                        attribute.dateTimeType !== "time"
                                    );
                                })
                                .sort(byAttributeName);
            setMappingAttributes(mappingAttributes)
        }
    }, [fetchedValues.attributes])

    function handleStartAttribute(e) {
        setProperty("startDateAttribute", e.target.value)
        if (
            e.target.value._id === properties.endDateAttribute._id ||
            e.target.value.dateTimeType !== properties.endDateAttribute.dateTimeType
        ) {
            setProperty("endDateAttribute", {})
        }
    }

    function handleEndAttribute(e) {
        setProperty("endDateAttribute", e.target.value)
    }

    function filterStartAttribute() {
        return mappingAttributes
    }

    function filterEndAttribute() {
        const startDateAttributeType = properties.startDateAttribute ? properties.startDateAttribute.dateTimeType : "";
        if (startDateAttributeType === "") {
            return mappingAttributes
        } else if (startDateAttributeType === "date") {
            const endDataAttributes = mappingAttributes.filter(attribute => attribute.dateTimeType === "date" && attribute._id !== properties.startDateAttribute._id)
            return endDataAttributes ? endDataAttributes : []
        } else if (startDateAttributeType === "datetime") {
            const endDataAttributes = mappingAttributes.filter(attribute => attribute.dateTimeType === "datetime" && attribute._id !== properties.startDateAttribute._id)
            return endDataAttributes ? endDataAttributes : []
        }
    }

    return (
        <>
            {
                mappingAttributes && mappingAttributes.length > 0 ?
                    <>
                        <div className="d-inline-block me-2">
                            <div className="form-label">
                                {t("form_labels.mapping_attributes.start_property")}
                            </div>
                            <DropDownList
                                style={{ width: "200px" }}
                                disabled={selectedComponent.hidden}
                                onChange={handleStartAttribute}
                                value={properties.startDateAttribute}
                                textField='attributeName'
                                dataItemKey='_id'
                                data={filterStartAttribute()}
                            />
                        </div>
                        <div className="d-inline-block me-2">
                            <div className="form-label">
                                {t("form_labels.mapping_attributes.end_property")}
                            </div>
                            <DropDownList
                                style={{ width: "200px" }}
                                disabled={selectedComponent.hidden}
                                onChange={handleEndAttribute}
                                value={properties.endDateAttribute}
                                textField='attributeName'
                                dataItemKey='_id'
                                data={filterEndAttribute()}
                            />
                        </div>
                    </>
                    :
                    <div>
                        {t("form_labels.mapping_attributes.no_properties_error")}
                    </div>
            }
        </>
    )
}

export default MappingAttributesForGanntChart;